/*
  Dainton Beer: small runtime layer over Alchemy.
  1. Prices: Alchemy (and the Wholesale Pricing Discount code inside theme.js)
     write plain "$21.00" into .theme-money elements. This rewrites them in the
     design system's form: a raised dollar sign, no cents unless they are real.
     It reads the text the theme produced and never recalculates a price.
  2. Header: Alchemy keeps it sticky; this slides it away while the visitor
     scrolls down and brings it back as soon as they scroll up. It stays put
     near the top of the page, while a menu, drawer or search is open, and
     while keyboard focus is inside it. Reduced motion: no slide (CSS).
  3. Filter drawer (collection and search): Alchemy opens it but leaves focus
     on the Filter button. Focus moves to the drawer's close button, Escape
     closes it, and focus returns to the Filter button.
*/
(function () {
  'use strict';

  var PRICE = /^\s*(From\s+)?\$\s?([\d,]+)(?:\.(\d{2}))?\s*(AUD)?\s*$/;

  function formatPrice(el) {
    if (el.getAttribute('data-d-price') === el.textContent) return;
    var m = PRICE.exec(el.textContent);
    if (!m) return;
    var figures = m[2] + (m[3] && m[3] !== '00' ? '.' + m[3] : '');
    var html = (m[1] ? '<span class="d-price__from">From </span>' : '') +
      '<span class="d-price__sign">$</span>' + figures + (m[4] ? ' AUD' : '');
    el.innerHTML = html;
    el.classList.add('d-price');
    el.setAttribute('data-d-price', el.textContent);
  }

  function formatAll(root) {
    var nodes = (root || document).querySelectorAll('.theme-money');
    for (var i = 0; i < nodes.length; i++) formatPrice(nodes[i]);
  }

  function start() {
    formatAll(document);
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () {
        pending = false;
        formatAll(document);
      });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

(function () {
  'use strict';

  var header = document.querySelector('.section-header');
  if (!header) return;
  var root = document.documentElement;
  var HIDDEN = 'd-header-hidden';
  var lastY = window.scrollY;
  var ticking = false;

  function held() {
    var b = document.body;
    return b.classList.contains('open-menu') || b.classList.contains('open-side-drawer') ||
      root.classList.contains('open-side-drawer') || b.classList.contains('search-active') ||
      header.contains(document.activeElement) && document.activeElement !== document.body;
  }
  function update() {
    ticking = false;
    var y = Math.max(0, window.scrollY);
    var dy = y - lastY;
    if (Math.abs(dy) < 6) return; // ignore jitter and momentum tails
    var clear = header.offsetHeight + 40;
    if (dy > 0 && y > clear && !held()) root.classList.add(HIDDEN);
    else if (dy < 0 || y <= clear) root.classList.remove(HIDDEN);
    lastY = y;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
  }, { passive: true });
  header.addEventListener('focusin', function () { root.classList.remove(HIDDEN); });
})();

(function () {
  'use strict';

  var show = document.querySelector('.js-show-filters');
  var hide = document.querySelector('.js-hide-filters');
  if (!show || !hide) return;
  var drawer = hide.closest('.side-drawer') || hide.parentElement;
  if (drawer && !drawer.id) drawer.id = 'FiltersDrawer';
  show.setAttribute('aria-expanded', 'false');
  if (drawer) show.setAttribute('aria-controls', drawer.id);

  function isOpen() {
    return document.documentElement.classList.contains('open-side-drawer');
  }
  show.addEventListener('click', function () {
    show.setAttribute('aria-expanded', 'true');
    window.setTimeout(function () { if (isOpen()) hide.focus(); }, 60);
  });
  function closed() {
    show.setAttribute('aria-expanded', 'false');
    show.focus();
  }
  hide.addEventListener('click', function () { window.setTimeout(closed, 0); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen() && drawer && drawer.contains(document.activeElement)) {
      hide.click();
    }
  });
})();
